import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';

export const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  // align-items: center;
  // margin-bottom: 20px; /* Spacing below the button */
`;

export const StyledBackButton = styled(BaseButton)`
  // font-size: 1.25rem; /* Larger font for touch devices */
  // padding: 10px 20px; /* Bigger padding for touch */
  // height: 50px; /* Bigger button height */
  background-color: #1890ff; /* Primary color */
  color: white;
  border-radius: 8px; /* Rounded edges */
  &:hover {
    background-color: #40a9ff; /* Hover effect */
  }
`;

interface BackButtonProps {
  onClick?: () => void;
}

export const GlobalBackButton: React.FC<BackButtonProps> = (props: BackButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    if (props.onClick) {
      props.onClick();
    } else {
      navigate(-1); // Navigate to the previous page
    }
  };

  return (
    <BackButtonWrapper>
      <StyledBackButton type="ghost" onClick={handleBack}>
        {t('common.back')} {/* Translatable label */}
      </StyledBackButton>
    </BackButtonWrapper>
  );
};
